module.exports={
  "approvals_dateStartFIlter": {
      "id": "approvals_dateStartFIlter",
      "eventName": "data_inicio",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Filtro lateral Aprovacao",
      "eventValue": 0
  },
  "approvals_searchFilter": {
      "id": "approvals_searchFilter",
      "eventName": "pesquisa_aprovacao",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Filtro lateral Aprovacao",
      "eventValue": 0
  },
  "approvals_dateEndFilter": {
      "id": "approvals_dateEndFilter",
      "eventName": "data_fim",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Filtro lateral Aprovacao",
      "eventValue": 0
  },
  "approvals_statusFilter": {
      "id": "approvals_statusFilter",
      "eventName": "status",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Filtro lateral Aprovacao",
      "eventValue": "{{label}}"
  },
  "approvals_usersFilters": {
      "id": "approvals_usersFilters",
      "eventName": "usuarios",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Filtro lateral Aprovacao",
      "eventValue": "{{label}}"
  },
  "approvals_approvalFluxFilter": {
      "id": "approvals_approvalFluxFilter",
      "eventName": "fluxo_aprovação",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Filtro lateral Aprovacao",
      "eventValue": "{{label}}"
  },
  "approvals_allReportsFilter": {
      "id": "approvals_allReportsFilter",
      "eventName": "select_todos_relatorios",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_dateFilterTable": {
      "id": "approvals_dateFilterTable",
      "eventName": "data",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_valueFilterTable": {
      "id": "approvals_valueFilterTable",
      "eventName": "valor_total",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_yourApprovalFilterTable": {
      "id": "approvals_yourApprovalFilterTable",
      "eventName": "sua_aprovacao",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_generalStatusFilterTable": {
      "id": "approvals_generalStatusFilterTable",
      "eventName": "status_geral",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_descriptionFilterTable": {
      "id": "approvals_descriptionFilterTable",
      "eventName": "descricao",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_memberFilterTable": {
      "id": "approvals_memberFilterTable",
      "eventName": "membro",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações | filtro",
      "eventValue": 0
  },
  "approvals_hoverTableItemHelper": {
      "id": "approvals_hoverTableItemHelper",
      "eventName": "hover_relatorio",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Tabela Aprovações",
      "eventValue": 0
  },
  "approvals_actions": {
      "id": "approvals_actions",
      "eventName": "acoes",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_approveAll": {
      "id": "approvals_approveAll",
      "eventName": "aprovar_tudo",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_reproveAll": {
      "id": "approvals_reproveAll",
      "eventName": "reprovar_tudo",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_send": {
      "id": "approvals_send",
      "eventName": "enviar",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_approveIndividual": {
      "id": "approvals_approveIndividual",
      "eventName": "aprovar_individual",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_reproveIndividual": {
      "id": "approvals_reproveIndividual",
      "eventName": "reprovar_individual",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_horusNotSync": {
      "id": "approvals_horusNotSync",
      "eventName": "horus_nao_sincronizado",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_observation": {
      "id": "approvals_observation",
      "eventName": "observacao_aprovar",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_confirm": {
      "id": "approvals_confirm",
      "eventName": "confirmar_aprovar",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_cancel": {
      "id": "approvals_cancel",
      "eventName": "cancelar_aprovar",
      "eventProduct": "aprovacoes",
      "eventCategory": "prestação de contas",
      "eventAction": "Aba da relatório",
      "eventValue": 0
  },
  "approvals_reprovalsCancel": {
    "id": "approvals_reprovalsCancel",
    "eventName": "cancelar_reprovar",
    "eventProduct": "aprovacoes",
    "eventCategory": "prestação de contas",
    "eventAction": "Aba da relatório",
    "eventValue": 0
  },
  "approvals_reprovalsConfirm": {
    "id": "approvals_reprovalsConfirm",
    "eventName": "confirmar_reprovar",
    "eventProduct": "aprovacoes",
    "eventCategory": "prestação de contas",
    "eventAction": "Aba da relatório",
    "eventValue": 0
  },
  "-approvals_goToNewVersion": {
    "id": "approvals_goToNewVersion",
    "eventName": "vex_aprovacao_nova_versao",
    "eventProduct": "aprovacoes",
    "screenName": "aprovacao_inicial",
    "eventAction": "click",
    "eventValue": 0
  }
}
